import React from "react";
import EmployeeCard from '../EmployeeCard/EmployeeCard';
import './style.css';



function EmployeeTable(props) {
  
  const { employees, currentSort, SortDirections} = props;
  
  
console.log(`${SortDirections}`)

  return (
    <table className="table table-hover table-bordered">
      <thead>
        <tr>
          <th scope="col"><div className='tableHeader'><h5>Image</h5></div></th>
          <th scope="col"><div className='tableHeader'><h5>First Name</h5></div></th>
          <th scope="col"><div className='tableHeader'><h5>Last Name</h5><button onClick={props.onSortChange} className="rounded-circle">
									<i className={`${SortDirections[currentSort].class}`} />
								</button></div></th>
          <th scope="col"><div className='tableHeader'><h5>Email</h5></div></th>
          <th scope="col"><div className='tableHeader'><h5>Phone</h5></div></th>
        </tr>
      </thead>
      <tbody>
      {employees.sort(SortDirections[currentSort].fn)
      .map(oneEmployee => ( 
      <EmployeeCard 
        key={oneEmployee.id.value} 
        firstName={oneEmployee.name.first} 
        lastName={oneEmployee.name.last} 
        picture={oneEmployee.picture.medium} 
        email={oneEmployee.email} 
        phone={oneEmployee.phone} 
        />))}
        </tbody>
    </table>
  );
}

export default EmployeeTable;

